<template>
  <div class="package">
    <ccs-header
      :title="pkg.name"
      :back="true"/>
    <div class="package-menu">
      <menu-tab v-for="(tab, index) in allowedTabs" :key="index"
        :to="tab.to" :text="tab.text" :params="tab.params" />
    </div>
    <div class="package-content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

import { PermissionsList } from '@/helpers/permissions';

import Header from '@/layouts/Header.vue';
import MenuTab from '@/components/MenuTab.vue';

export default {
  name: 'Package',
  components: {
    'ccs-header': Header,
    MenuTab,
  },
  data() {
    return {
      tabs: [{
        text: 'Информация',
        to: 'package_info',
        requiredPermissions: [
          PermissionsList.PackageView,
        ],
      }, {
        text: 'Содержимое пакета',
        to: 'package_units',
        requiredPermissions: [
          PermissionsList.PackageView,
        ],
      }, {
        text: 'Квоты',
        to: 'package_quotas',
        params: { page: 1 },
        requiredPermissions: [
          PermissionsList.PackageQuotaView,
          PermissionsList.PackageQuotaViewAll,
        ],
      }]
    };
  },
  computed: {
    ...mapState('packages', ['pkg']),
    ...mapState('session', ['permissions']),
    allowedTabs() {
      return this.tabs.filter(tab => this.isAccessAllowed(tab.requiredPermissions));
    },
  },
  methods: {
    ...mapActions('packages', ['getPackage']),
    ...mapMutations('packages', ['setPackageID']),
    ...mapMutations('events', ['setEventID']),
    isAccessAllowed(requiredPermissions) {;
      let result = false;
      if (!requiredPermissions) {
        result = true;
        return result;
      } else {
        requiredPermissions.forEach(slug => {
          result = result || this.permissions[slug];
        });
        return result;
      }
    },
  },
  async created() {
    this.setEventID(this.$route.params.eventID),
    this.setPackageID(this.$route.params.packageID),
    await this.getPackage();
  },
};
</script>

<style lang="scss" scoped>
.package {
  min-height: 100%;
  min-width: 100%;
  background: $neutralLightest;

  &-content {
    padding: 25px 33px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background: #fff;
  }

  &-menu {
    margin: 0 33px 9px 33px;
  }

}
</style>
